<script type="text/jsx">
import { mapGetters } from 'vuex';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import partnerEntryMixin from '@/views/config/partner-refer/mixin/partner-entry';

export default {
  name: 'partner-plan-cart',
  mixins: [ConfirmComponent, partnerEntryMixin],
  computed: {
    ...mapGetters(['partnerRefer']),
  },
  render() {
    const Comp = this.getInitPlanConfigContent();
    return Comp ? <zm-dialog
      class="opc-partner-init-modal-dialog"
      visible={this.visible}
      show-close
      width="890px"
      onClose={this.handleCancel}>
      <Comp onClose={this.handleCancel} />
    </zm-dialog> : null;
  },
};
</script>

<style lang="scss">
.opc-partner-init-modal-dialog {
  .zm-dialog__headerbtn .zm-dialog__close {
    color: #323539;
  }

  .zm-dialog__header {
    padding-bottom: 0px;
  }


}
</style>

